import * as React from "react";
import Loader from "react-loaders";
import "./small-loader.scss";

interface Props {
  active: boolean;
}

export const SmallLoader = (props: Props) => {
  return (
    <div className="loader-small">
      <Loader type="line-scale" active={props.active} />
    </div>
  );
};
